import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/index.vue"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/readme",
    name: "Readme",
    component: () => import("@/views/readme/index.vue"),
    meta: {
      title: "接口文档",
    },
  },
  {
    path: "/",
    name: "Home",
    redirect: "/appList",
    component: Layout,
    meta: {
      title: "首页",
    },
    children: [
      {
        path: "/appList",
        name: "AppList",
        component: () => import("@/views/appList/index.vue"),
        meta: {
          title: "应用程序管理",
        },
      },
      {
        path: "/smsSign",
        name: "SmsSign",
        component: () => import("@/views/smsSign/index.vue"),
        meta: {
          title: "短信签名管理",
        },
      },
      {
        path: "/smsRecord",
        name: "SmsRecord",
        component: () => import("@/views/smsRecord/index.vue"),
        meta: {
          title: "发送记录查询",
        },
      },
      {
        path: "/smsCount",
        name: "SmsCount",
        component: () => import("@/views/smsCount/index.vue"),
        meta: {
          title: "发送量统计",
        },
      },
      {
        path: "/ipConfig",
        name: "IpConfig",
        component: () => import("@/views/ipConfig/index.vue"),
        meta: {
          title: "IP白名单管理",
        },
      },
      {
        path: "/phoneBlacklist",
        name: "PhoneBlacklist",
        component: () => import("@/views/phoneBlacklist/index.vue"),
        meta: {
          title: "手机号黑名单",
        },
      },
      {
        path: "/smsTest",
        name: "SmsTest",
        component: () => import("@/views/smsTest/index.vue"),
        meta: {
          title: "发送短信测试",
        },
      },
      {
        path: "/vendorConfig",
        name: "VendorConfig",
        component: () => import("@/views/vendorConfig/index.vue"),
        meta: {
          title: "厂商管理",
        },
      },
      {
        path: "/vendorAlert",
        name: "VendorAlert",
        component: () => import("@/views/vendorAlert/index.vue"),
        meta: {
          title: "告警记录",
        },
      },
      {
        path: "/dlqMessage",
        name: "DlqMessage",
        component: () => import("@/views/dlqMessage/index.vue"),
        meta: {
          title: "死信消息管理",
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
